var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('base-input',{staticClass:"w-full",attrs:{"label":"Groups "}},[_c('b-input',{attrs:{"placeholder":"Create groups "}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }